var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cp-grid',{attrs:{"stretch-content":"","align":"center"}},_vm._l((_vm.gifs),function(gif){return _c('cp-grid-item',{key:gif.id,attrs:{"span":_vm.renderGifScreen}},[_c('img',{staticClass:"gif-image",staticStyle:{"cursor":"pointer"},attrs:{"src":gif.images.fixed_height.url,"alt":""},on:{"click":function($event){return _vm.selectGif(gif)}}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }